<template>
<div class="chapter">
<div class="inner_page">
<a id="pii"></a><a id="piii"></a><a id="piv"></a>
<div class="copyright">
<p class="center ">Copyright © 2011 by Julian Guthrie</p>
<p class="center spaceabove1"><span class="smallcaps">ALL RIGHTS RESERVED</span></p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>The Library of Congress has cataloged the print edition as follows:</em></p>
<p class="center ">Guthrie, Julian.<br/>
The grace of everyday saints : how a band of believers lost<br/>
their church and found their faith / Julian Guthrie.<br/>
p. cm.</p>
<p class="center "><span class="smallcaps">ISBN</span> 978-0-547-13304-1</p>
<p class="center ">1. St. Brigid Catholic Church (San Francisco, Calif.)—History. 2. San Francisco (Calif.)—Church history. I. Title.</p>
<p class="center "><span class="smallcaps">BX</span>4603.<span class="smallcaps">S</span>5<span class="smallcaps">G</span>88 2011<br/>
282’.7946109049—dc22<br/>
2010049819</p>
<p class="center spaceabove1">eISBN 978-0-547-52361-3<br/>
v2.0421</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?23225904